var React = require("react");
var PackageCard =             require("./cards/PackageCard.jsx");
var LibraryCard =             require("./cards/LibraryCard.jsx");
var ApplicationContext = require("../config/ApplicationContext.js");
var DisplayAssets =      require("./DisplayAssets.jsx");

class DisplayAssetsHome extends React.Component {

    constructor() {
        super();

        this.getDefaultAssetsConfig = this.getDefaultAssetsConfig.bind(this);
    }


    // Determine whether a package has a finished 3D thumbnail. We can't inspect the
    // thumbnail endpoint with fetch: it 302-redirects to a presigned S3 URL that sends
    // no CORS headers, so cross-origin fetch is blocked.
    // We can however load the image in an <img> and then check the size only (there's no access to the redirected URL).
    // The no3d placeholder is 144x144 while thumbnails are 256x256
    // Testing width >= 200 means a real thumbnail is attached.
    hasFinishedThumbnail(asset){
        // Image only exists in the browser, when rendered on server, we skip and fall back to defaults (if any)
        if(typeof Image === "undefined") return Promise.resolve(false);

        return new Promise(resolve => {
            const img = new Image();
            let settled = false;
            const finish = result => {
                if (settled) return;
                settled = true;
                clearTimeout(timer);
                img.onload = img.onerror = null;
                resolve(result);
            };
            const timer = setTimeout(() => finish(false), 8000);
            img.onload = () => finish(img.naturalWidth >= 200); // 256 real vs 144 placeholder
            img.onerror = () => finish(false);
            img.src = asset.thumbnail;
        });
    }

    justReturnTrue(){
         return true;
    }

    getDefaultAssetsConfig(){
        const examplesHubCondition = `hub=${ApplicationContext.contentServer.examplesHubId}`;
        return {
            packages: {
                endpoint: "explore/packages",
                numberOfAssets: 6,
                pageSize: 100,
                condition: examplesHubCondition,
                displayName: "Packages",
                cssCardTag: "package",
                CardType: PackageCard,
                assetCondition: this.hasFinishedThumbnail,
                defaultAssets: [],
                linkTo: "/search/packages",
                linkName: "Browse Packages",
            },

            libraries: {
                endpoint: "explore/libraries",
                numberOfAssets: 6,
                pageSize: 6,
                condition: examplesHubCondition,
                displayName: "Libraries",
                cssCardTag: "library",
                CardType: LibraryCard,
                assetCondition: this.justReturnTrue,
                defaultAssets: [],
                linkTo: "/search/libraries",
                linkName: "Browse Libraries",
            },
            defaultSelected: "packages"
        };
    }

    render() {
        return (
            <DisplayAssets
                {...this.props}
                tabs={this.getDefaultAssetsConfig()}
            />
        );
    }

}


module.exports = DisplayAssetsHome;
